<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.order_created_time_date="{ item }">
            {{$rc.pretty(item.order_created_time,'date')}}
        </template>

        <template v-slot:item.order_created_time_time="{ item }">
            {{$rc.pretty(item.order_created_time,'time')}}
        </template>

        <template v-slot:item.endpoint="{ item }">
            {{$rc.pretty(item.endpoint,'endpoint_no_parens')}}
        </template>

        <template v-slot:item.order_number="{ item }">
            {{orderNumber(item.order_number)}}
        </template>

        <template v-slot:item.order_amount="{ item }">
            {{$rc.pretty(item.order_amount, 'millicents_dollars')}}
        </template>

        
    
    </v-data-table>

   

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Date', value: 'order_created_time_date'}, 
                { text: 'Time', value: 'order_created_time_time'},
                { text: 'Type', value: 'type'},
                { text: 'First Name', value: 'first_name'},
                { text: 'Last Name', value: 'last_name'},
                { text: 'Phone', value: 'endpoint'},  
                { text: 'Order Number', value: 'order_number' }, 
                { text: 'Amount', value: 'order_amount' }, // *
                { text: 'Payment Method', value: 'order_payment_method' }
            ],

        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/integrations/ebr-events',
                'timeout': 30000,
            
                'params' : {
                        'full_text': this.full_text,
                        'sort': 'order_created_time:desc',
                        'organization_id': this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        orderNumber(value)
        {
            if ( value == null || value.length > 8 )
                return null;

            return value;
        }
        
    },

    computed: {
        title() {
            return 'Search '+this.$rc.pretty(this.$route.params.content_type, 'enum_integration_name')+' Order History (by phone number)';
        },
    },
}
</script>

<style lang="scss" scoped>
</style>